import React from "react";
import "./index.scss";
import { TextField, Select } from "shared";

type LayoutItemProps = {
  item: any;
  callback: (attributeName: string, val: any) => void;
  statusData: any;
  onItemChanged?: (
    attributeName: string,
    item: any,
    isSelected: boolean
  ) => void;
};

const LayoutItem = ({
  item,
  callback,
  statusData,
  onItemChanged,
}: LayoutItemProps) => {
  const {
    attributeName,
    type,
    data,
    label,
    disabled,
    options,
    isMultiple,
    placeholder,
  } = item;
  const getBody = () => {
    let body = null;
    if (type == "check") {
      body = (
        <input
          type="checkbox"
          checked={!!statusData?.[attributeName]}
          onChange={(evt) => callback(attributeName, evt.target.checked)}
        />
      );
    } else if (type == "dropdown") {
      let value = options.find(
        (item: any) => item.value == statusData?.[attributeName]
      );
      if (isMultiple) {
        value = statusData?.[attributeName];
      } else {
        value = value ? [value] : [];
      }
      body = (
        <Select
          isMultiple={isMultiple}
          editable
          readOnly={disabled}
          data={options}
          label={label}
          values={value}
          onChanged={(selectedOptions) =>
            callback(
              attributeName,
              isMultiple ? selectedOptions : selectedOptions?.[0] || {}
            )
          }
          onItemChanged={(item, isSelected) =>
            onItemChanged?.(attributeName, item, isSelected)
          }
        />
      );
    } else {
      body = (
        <TextField
          type="outline"
          textArea={type == "textarea"}
          readonly={disabled}
          placeholder={placeholder || label}
          value={data || statusData?.[attributeName] || ""}
          onChange={(e) => {
            let val = e.target.value;
            if (type == "number") {
              val = parseInt(val);
            }
            callback(attributeName, val);
          }}
        />
      );
    }
    return body;
  };
  return (
    <div className="layout-item__container">
      <span className="layout-item__label">{label}:</span>
      <div className="layout-item__data">{getBody()}</div>
    </div>
  );
};

export default LayoutItem;
